import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { FiEdit, FiTrash } from 'react-icons/fi';
import ConditionalButton from '../components/common/ConditionalButton';
import ConditionalActions from '../components/common/ConditionalActions';
import ResponsiveDataList from '../components/common/ResponsiveDataList';
import MobileCard from '../components/common/MobileCard';

const AnneesScolairesPage = () => {
    // eslint-disable-next-line no-unused-vars
    const { user } = useAuth();
    const [annees, setAnnees] = useState([]);
    const [form, setForm] = useState({
    annee_scolaire: '',
    ouverte: 'N',
    ouvrirClasses: false,
    associerMatieresProfs: false
  });
    const [editingId, setEditingId] = useState(null);
    const [page, setPage] = useState(1);
    const [loadingCreate, setLoadingCreate] = useState(false);
    const pageSize = 10;
    const totalPages = Math.ceil(annees.length / pageSize) || 1;
    const paginatedAnnees = annees.slice((page - 1) * pageSize, page * pageSize);

  const fetchAnnees = async () => {
    const res = await api.get('/annees-scolaires');
    setAnnees(res.data.data || []);
  };

  useEffect(() => { fetchAnnees(); }, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoadingCreate(true);
  try {
        if (editingId) {
        await api.put(`/annees-scolaires/${editingId}`, form);
        } else {
        const res = await api.post('/annees-scolaires', {
            ...form,
            ouvrir_classes: form.ouvrirClasses ? 1 : 0,
            associer_matieres_profs: form.associerMatieresProfs ? 1 : 0
        });
        // GESTION ERREUR DEDOULEE
        if (res.data && res.data.success === false && res.data.message && res.data.message.includes('existe déjà')) {
            Swal.fire({
            icon: 'warning',
            title: "Doublon",
            text: res.data.message,
            });
            setLoadingCreate(false);
            return;
        }
        if (res.data && res.data.success) {
            Swal.fire({
                icon: 'success',
                title: 'Succès',
                text: res.data.message,
                timer: 3000,
                showConfirmButton: false
            });
        }
        }
        setForm({ annee_scolaire: '', ouverte: 'N' });
        setEditingId(null);
        fetchAnnees();
        setPage(1);
    } catch (err) {
            Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: (err.response && err.response.data && err.response.data.message) || 'Erreur inattendue.',
            confirmButtonText: 'OK'
            });
    } finally {
        setLoadingCreate(false);
    }
};

  const remove = async (id) => {
    try{
    await api.delete(`/annees-scolaires/${id}`);
    fetchAnnees();
    setPage(1);
    } catch (err) {
        if (err.response && err.response.status === 403) {
            Swal.fire({
            icon: 'error',
            title: 'Accès interdit',
            text: "Vous n'avez pas la permission pour effectuer cette action.",
            confirmButtonText: 'OK'
            });
        } else {
            // gestion des autres erreurs
            Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: (err.response && err.response.data && err.response.data.message) || 'Erreur inattendue.',
            confirmButtonText: 'OK'
            });
        }
    }
  };
  return (
    <div className="max-w-3xl mx-auto p-4">
      <h2 className="text-xl font-bold mb-2">Années scolaires</h2>
      <form className="mb-6 flex flex-col gap-2 items-start w-full" onSubmit={handleSubmit}>
        <div className="flex gap-4 w-full">
          <div className="flex-1">
            <label className="block mb-1">Année scolaire</label>
            <input className="border rounded px-2 py-1 w-full" required
              value={form.annee_scolaire}
              onChange={e => setForm(f => ({...f, annee_scolaire: e.target.value}))}
              placeholder="2024-2025"
              maxLength={9}
            />
          </div>
          <div className="flex-1">
            <label className="block mb-1">Ouverte</label>
            <select className="border rounded px-2 py-1 w-full" value={form.ouverte}
              onChange={e => setForm(f => ({...f, ouverte: e.target.value}))}>
              <option value="N">Non</option>
              <option value="Y">Oui</option>
            </select>
          </div>
        </div>
        <div className="mt-2 mb-2 w-full flex gap-5">
          <div className="flex flex-col flex-1">
            <label className="flex items-center text-sm mb-1 font-medium text-gray-700 gap-3">
              <input
                type="checkbox"
                className="rounded accent-primary-600 w-5 h-5 border-gray-400 focus:ring-2 focus:ring-primary-600"
                checked={form.ouvrirClasses}
                onChange={e => setForm(f => ({ ...f, ouvrirClasses: e.target.checked }))}
              />
              Ouvrir les classes avec l'année
            </label>
            <label className="flex items-center text-sm font-medium text-gray-700 gap-3 mt-1 opacity-90">
              <input
                type="checkbox"
                className="rounded accent-primary-600 w-5 h-5 border-gray-400 focus:ring-2 focus:ring-primary-600"
                checked={form.associerMatieresProfs}
                onChange={e => setForm(f => ({ ...f, associerMatieresProfs: e.target.checked }))}
                disabled={!form.ouvrirClasses}
              />
              Associer les matières et professeurs
            </label>
          </div>
        </div>
        <div className="flex items-end justify-end w-full">
            <ConditionalButton
                entity="annees"
                permission={editingId ? "update" : "create"}
                type="submit"
                disabled={loadingCreate}
                className={
                    editingId
                        ? "bg-primary-600 text-white px-3 py-1 rounded hover:bg-primary-700 transition"
                        : "bg-primary-600 text-white px-3 py-1 rounded hover:bg-primary-700 transition"
                }
            >
            {loadingCreate && (
                <svg className="animate-spin h-4 w-4 text-white inline mr-2" viewBox="0 0 24 24" fill="none">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"/>
                </svg>
            )}
            {editingId ? 'Modifier l\'année scolaire' : 'Ajouter une année scolaire'}
            </ConditionalButton>
        </div>
        {editingId && (
          <button
            type="button"
            onClick={() => { setEditingId(null); setForm({ annee_scolaire: '', ouverte: 'N' }); }}
            className="ml-2 px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 transition text-gray-700"
          >
            Annuler
          </button>
        )}
      </form>
      <ResponsiveDataList
        isLoading={false}
        isEmpty={paginatedAnnees.length === 0}
        emptyMessage="Aucune année scolaire"
        mobileCards={paginatedAnnees.map((a) => (
          <MobileCard
            key={a.id}
            title={a.annee_scolaire}
            fields={[{ label: 'Ouverte', value: a.ouverte === 'Y' ? 'Oui' : 'Non' }]}
            actions={
              <ConditionalActions
                entity="annees"
                onEdit={() => { setEditingId(a.id); setForm({ annee_scolaire: a.annee_scolaire, ouverte: a.ouverte }); }}
                onDelete={() => remove(a.id)}
                editIcon={FiEdit}
                deleteIcon={FiTrash}
                className="flex space-x-1"
              />
            }
          />
        ))}
      >
      <table className="min-w-full border rounded mt-8">
        <thead>
          <tr>
            <th className="border px-2 py-1 bg-gray-300">Annee scolaire</th>
            <th className="border px-2 py-1 bg-gray-300 text-center">Ouverte</th>
            <th className="border px-2 py-1 bg-gray-300">Action</th>
          </tr>
        </thead>
        <tbody>
          {paginatedAnnees.map(a => (
            <tr key={a.id} className="odd:bg-white even:bg-gray-50">
              <td className="border px-2 py-1">{a.annee_scolaire}</td>
              <td className="border px-2 py-1 text-center">{a.ouverte === 'Y' ? 'Oui' : 'Non'}</td>
              <td className="border px-2 py-1 flex gap-1 items-center justify-center">
                <ConditionalActions
                  entity="annees"
                  onEdit={() => { setEditingId(a.id); setForm({ annee_scolaire: a.annee_scolaire, ouverte: a.ouverte }); }}
                  onDelete={() => remove(a.id)}
                  editIcon={FiEdit}
                  deleteIcon={FiTrash}
                  className="flex space-x-1"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </ResponsiveDataList>
      <div className="flex justify-center items-center gap-1 mt-4 flex-wrap pb-4">
        <button onClick={() => setPage(1)} disabled={page === 1} className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-sm">Premier</button>
        <button onClick={() => setPage(page - 1)} disabled={page === 1} className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-sm">Précédent</button>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
            <button
            key={p}
            className={`px-2 py-1 rounded mx-0.5 text-sm ${p === page ? 'bg-primary-600 text-white' : 'bg-gray-100 hover:bg-primary-100 text-gray-700'}`}
            onClick={() => setPage(p)}
            disabled={p === page}
            >{p}</button>
        ))}
        <button onClick={() => setPage(page + 1)} disabled={page === totalPages} className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-sm">Suivant</button>
        <button onClick={() => setPage(totalPages)} disabled={page === totalPages} className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-sm">Dernier</button>
        </div>
    </div>
  );
};

export default AnneesScolairesPage;